import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatError } from "../lib/api";
import ShareButtons from "../components/ShareButtons";

export default function Ecard() {
  const { id } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get(`/ecards/${id}`).then((r) => setCard(r.data)).catch((e) => setError(formatError(e))); }, [id]);
  if (error) return <div data-testid="ecard-error" className="max-w-xl mx-auto px-4 py-24 text-center text-red-700">{error}</div>;
  if (!card) return <div className="p-10 text-center">Loading…</div>;
  return (
    <div data-testid="ecard-page" className="max-w-2xl mx-auto px-4 py-16">
      <div className="overline text-center">A blessing for {card.first_name}</div>
      <div className="mt-6 bg-[#4A0E17] rounded-[28px] p-6 sm:p-10 text-center text-[#F3E5AB] shadow-2xl relative overflow-hidden">
        {card.image_url && <img data-testid="ecard-image" src={card.image_url} alt={card.deity_name} className="w-full max-h-[420px] object-cover rounded-2xl" />}
        {card.festival_name && <div data-testid="ecard-festival" className="mt-6 text-xs tracking-[0.3em] uppercase text-[#D4AF37]">{card.festival_name} · {card.festival_date}{card.days_away > 0 ? ` · in ${card.days_away} days` : ""}</div>}
        <div data-testid="ecard-mantra" className="font-devanagari text-2xl sm:text-3xl text-[#D4AF37] mt-4">{card.mantra}</div>
        {card.mantra_meaning && <div className="text-xs text-[#F3E5AB]/60 mt-2 italic">{card.mantra_meaning}</div>}
        <p data-testid="ecard-blessing" className="font-serif text-lg sm:text-xl leading-relaxed text-[#FAF6F0] mt-6">{card.blessing}</p>
        <div className="mt-6 text-sm text-[#D4AF37]">— with love from Pancham Dham</div>
      </div>
      <div className="mt-8 flex flex-col items-center gap-4">
        <ShareButtons title="A blessing from Pancham Dham" text={`${card.deity_name} blessing for ${card.festival_name || "the festival season"}: ${card.blessing}`} />
        {card.deity_slug && <Link to={`/deities/${card.deity_slug}`} data-testid="ecard-deity-link" className="text-sm text-[#E65100] font-semibold">Learn about {card.deity_name} →</Link>}
      </div>
    </div>
  );
}
